import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getLatestArticles(3);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-900 mb-3">
            精选文章
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            为您精选91n平台最新、最受欢迎的内容，助您快速上手使用
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-lg overflow-hidden hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${article.title} - 91n`}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span className="bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full">
                    {article.category === 'guide' ? '使用指南' :
                     article.category === 'address' ? '最新地址' :
                     article.category === 'faq' ? '常见问题' :
                     article.category === 'news' ? '平台动态' :
                     article.category === 'safety' ? '安全须知' : '使用技巧'}
                  </span>
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200"
          >
            浏览全部文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}